import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router';
import Banner from '../Components/Banner/Banner';
import NQTFooter from '../Components/NQTFooter/NQTFooter';
import { accountLoginCheckStart } from '../redux/account';
import { loadAppSettingsStart } from '../redux/appSettings';
import { loadControlsStart } from '../redux/controls';

function AppContainer(): JSX.Element {
  const dispatch = useDispatch();
  const fontUrl = process.env.REACT_APP_HEADER_INC_FONT;
  const headerJsUrl = process.env.REACT_APP_HEADER_JS_URL;
  const headerIncApiUrl = process.env.REACT_APP_HEADER_INC_API_URL;
  const headerCssUrl = process.env.REACT_APP_HEADER_CSS_URL;
  const environmentRootUrl = process.env.REACT_APP_ENVIRONMENT_ROOT_URL;
  const footerJsUrl = process.env.REACT_APP_FOOTER_JS_URL;
  const footerCssUrl = process.env.REACT_APP_FOOTER_CSS_URL;

  useLayoutEffect(() => {
    dispatch(loadControlsStart());
    dispatch(loadAppSettingsStart());
    dispatch(accountLoginCheckStart());
  }, [dispatch]);

  return (
    <>
      <div className='nqt-app-container'>
        <div className='nqt-header-container'>
          <ndetools-headerinc font-url={fontUrl} header-url={headerJsUrl} header-css={headerCssUrl}
            header-inc={headerIncApiUrl} header-include={headerIncApiUrl}>
          </ndetools-headerinc>
        </div>
        <Banner />
        <Outlet />
        <NQTFooter />
      </div>
      <ndetools-footerinc environment-root={environmentRootUrl}
        font-url={fontUrl} footer-js={footerJsUrl}
        footer-css={footerCssUrl}>
      </ndetools-footerinc>
    </>
  );
}

export default AppContainer;